import React from 'react';
const ChatConsoleChatSVG_ = ({ color = 'black', className, ...props }) => {
  return (
    <div style={{ display: 'flex' }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <g id="vuesax/linear/message">
          <g id="vuesax/linear/message_2">
            <g id="message">
              <path
                id="Vector"
                d="M5.66671 12.6666H5.33337C2.66671 12.6666 1.33337 12 1.33337 8.66665V5.33331C1.33337 2.66665 2.66671 1.33331 5.33337 1.33331H10.6667C13.3334 1.33331 14.6667 2.66665 14.6667 5.33331V8.66665C14.6667 11.3333 13.3334 12.6666 10.6667 12.6666H10.3334C10.1267 12.6666 9.92671 12.7666 9.80004 12.9333L8.80004 14.2666C8.36004 14.8533 7.64004 14.8533 7.20004 14.2666L6.20004 12.9333C6.09337 12.7866 5.84671 12.6666 5.66671 12.6666Z"
                stroke={color}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                id="Vector_2"
                d="M10.6643 7.33333H10.6703"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                id="Vector_3"
                d="M7.99703 7.33333H8.00302"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                id="Vector_4"
                d="M5.32967 7.33333H5.33566"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default ChatConsoleChatSVG_;
